<template>
    <div id="content" v-if="!loading">
        <div class="inner">
          <p class="paging">
            <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
          </p>
            <h1>{{ entity.name }}</h1>
        </div>
        <div class="responsiveTabs">
            <ul class="tabs">
                <li :class="{'r-tabs-state-active' : this.$route.name === 'vodPackagesSettings'}"><a
                    @click.stop="openRoute('vodPackagesSettings')" v-translate>Vlastnosti</a></li>
              <li :class="{'r-tabs-state-active' : this.$route.name === 'vodPackagesPrices'}"><a
                  @click.stop="openRoute('vodPackagesPrices')" v-translate>Ceny</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'vodPackagesVideos'}"><a
                    @click.stop="openRoute('vodPackagesVideos')" v-translate>Videa</a></li>
            </ul>

                <router-view
                    :entity="entity"
                />
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
            </p>
          </section>
        </div>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"

export default {
    name: "VodPackagesDetail",
    mixins: [
        detailActions,
    ],
    data() {
        return {
            entityName: "vodPackage",
            moduleName: "vodPackages",
            loading: false,
        }
    },
    created(VodPackageService) {
        this.entityService = VodPackageService
        this.createdInit();
    },
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodPackages/VodPackagesDetail.vue